const PendingApprove = ({ color }: any) => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.8337 1.66602L6.41699 8.08268'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8337 1.66602L8.75032 13.3327L6.41699 8.08268L1.16699 5.74935L12.8337 1.66602Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default PendingApprove
